import type * as Phaser from 'phaser';

export interface BurstOptions {
  count?: number;
  minSpeed?: number;
  maxSpeed?: number;
  radius?: number;
  lifeMs?: number;
  depth?: number;
}

/**
 * Phun N hạt từ (x, y) toả tròn, fade + scale down.
 * Hand-rolled (không dùng Phaser ParticleEmitter để giữ bundle nhẹ + control chi tiết).
 */
export function emitBurst(
  scene: Phaser.Scene,
  x: number,
  y: number,
  color: number,
  opts: BurstOptions = {},
): void {
  const count = opts.count ?? 6;
  const minSpeed = opts.minSpeed ?? 60;
  const maxSpeed = opts.maxSpeed ?? 120;
  const radius = opts.radius ?? 3;
  const lifeMs = opts.lifeMs ?? 420;
  const depth = opts.depth ?? 35;
  for (let i = 0; i < count; i++) {
    const angle = (Math.PI * 2 * i) / count + Math.random() * 0.4;
    const speed = minSpeed + Math.random() * (maxSpeed - minSpeed);
    const dx = Math.cos(angle) * (speed * lifeMs) / 1000;
    const dy = Math.sin(angle) * (speed * lifeMs) / 1000;
    const r = radius + Math.random() * 1.5;
    const particle = scene.add.circle(x, y, r, color, 1).setDepth(depth);
    scene.tweens.add({
      targets: particle,
      x: x + dx,
      y: y + dy,
      alpha: 0,
      scale: 0.3,
      duration: lifeMs,
      ease: 'Quad.easeOut',
      onComplete: () => particle.destroy(),
    });
  }
}
